import { useEffect, useRef } from "react";

export const useResetOnOpen = <T>(
	open: boolean,
	value: T,
	reset: (value: T) => void,
) => {
	const valueRef = useRef(value);
	const resetRef = useRef(reset);

	useEffect(() => {
		valueRef.current = value;
		resetRef.current = reset;
	});

	useEffect(() => {
		if (open) {
			resetRef.current(valueRef.current);
		}
	}, [open]);
};
